export default __webpack_public_path__ + "static/media/arrows-merge.b65faa00.svg";